module.exports = __webpack_public_path__ + "img/punyshort.85bdeeeb.png";